const catiaPythonCourse = {
    id: "catia-python",
    name: "CATIA V5 Customization & Design Automation Using Python Programming",

    hero: {
        title: "CATIA V5 Customization & Design Automation Using Python Programming",
         subtitle: "Live & Interactive Online Training",

        logo: "/Python_Logo.webp",

        points: [
            "Unlock the full power of CATIA by learning how to automate Part Design, Assemblies, Drafting, and more using Python. Whether you’re in aerospace, automotive, or manufacturing, this program equips you with real-world scripting skills to build intelligent tools, speed up design cycles, and become a standout CAD automation expert.",

            "Decade of Experience in individual and corporate training\nWith over a decade of experience in CATIA Customization & Design Automation, FeesWorth has become a go-to name for individuals and corporate teams looking to master advanced CAD automation. We’ve delivered successful training programs to global engineering leaders like Molex, Valeo, Bradken, Mold Masters,…and many more.",

            "💼 Proven Student Success Across Top Companies\nOur students are already placed in top-tier companies such as Honeywell, TCS, Cognizant, Tata Technologies, L&T Technology Services, ITC Infotech, Tech Mahindra, Ford, Kennametal, and others.",

            "💰 4X to 5X Salary Growth — From ₹0–10 LPA to ₹20–40 LPA\nWe have a proven track record of helping CAD professionals and design engineers shift from low-paying roles high-paying, high-impact automation careers. Many of our students have experienced salary jumps from ₹0–10 LPA to ₹20–40 LPA, After completing the course."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "While CATIA Design Engineers earn ₹5–10 LPA, those skilled in Python-based automation are securing ₹20–40 LPA roles. This growing demand reflects the industry’s need for engineers who can streamline workflows with smart, automated tools.Learning CATIA automation with Python is more than a skill—it’s a career upgrade."
        },
        {
            title: "Good Demand",
            description:
                "CATIA Design is common, making the job market highly competitive.\nCATIA Automation with Python is rare and sets you apart.\nAutomate workflows, build custom tools, and integrate smart systems.\nBecome a high-demand specialist ready for top-paying roles."
        },
        {
            title: "Easy to Learn",
            description:
                "CATIA Design is simple, but automation with Python takes deeper skills.\nNo worries—we simplify the complex with step-by-step guidance.\nLearn to build powerful tools with real-world, hands-on support.\nBecome confident in customizing CATIA like a pro."
        }
    ],

    whyLearn: [
        {
            title: "Boost Your Productivity",
            description:
                "Automate repetitive modeling, drafting, and assembly tasks to save hours of manual work."
        },
        {
            title: "Work Smarter, Not Harder",
            description:
                "Write Python scripts to handle complex design workflows with just a few lines of code—eliminating tedious clicks."
        },
        {
            title: "Stand Out in the Job Market",
            description:
                "CAD automation is a high-demand skill. Companies seek engineers who can combine design knowledge with programming."
        },
        {
            title: "Customize CATIA to Fit Your Workflow",
            description:
                "Build tools tailored to your company’s design standards, naming conventions, and documentation processes."
        },
        {
            title: "Modernize Legacy Macros",
            description:
                "Replace outdated VBScript/CATScript macros with clean, scalable, and maintainable Python code."
        },
        {
            title: "Integrate with Other Tools",
            description:
                "Use Python to connect CATIA with Excel, databases, PLM/ERP systems, or even cloud services for end-to-end automation."
        },
        {
            title: "Learn a Universal Programming Language",
            description:
                "Python isn’t just for CAD—your knowledge applies to automation, data analysis, web tools, and more."
        },
        {
            title: "Handle Complex Projects with Ease",
            description:
                "From design rule checks to BOM automation, Python lets you tackle large assemblies and batch processes efficiently."
        },
        {
            title: "Improve Accuracy & Reduce Errors",
            description:
                "Automated scripts enforce rules and eliminate manual entry mistakes, ensuring consistency across designs."
        },
        {
            title: "Be Future-Ready for Digital Engineering",
            description:
                "Automation is at the heart of Industry 4.0. Python + CATIA puts you on the cutting edge of smart engineering workflows."
        }
    ],

    syllabus: [
        {
            name: "CATIA V5 using Python",
            modules: [
                {
                    number: 1,
                    title: "Introduction & Setup",
                    topics: [
                        "Overview of CATIA V5 Architecture and Automation Scope",
                        "Introduction to Python for CATIA V5 Automation",
                        "Setting up Python and CATIA V5 Automation Environment",
                        "Installing and configuring PyCharm for CATIA scripting"
                    ]
                },
                {
                    number: 2,
                    title: "Working with CATIA Part Documents",
                    topics: [
                        "Opening, creating, and saving Part Documents via Python",
                        "Creating and managing Bodies, Geo Sets, and Axis Systems",
                        "Creating basic Features (Pads, Holes, Pockets, etc.)",
                        "Modifying existing Features using Python",
                        "Creating Parameters and linking them to geometry"
                    ]
                },
                {
                    number: 3,
                    title: "CATIA Drafting Automation",
                    topics: [
                        "Creating a Drawing Document from a Part",
                        "Adding and customizing Views",
                        "Modifying Title Blocks and Drawing Sheet Properties",
                        "Adding and replacing Notes",
                        "Inserting Tables and Leaders",
                        "Creating links between Drawing and Part data"
                    ]
                },
                {
                    number: 4,
                    title: "Measurements and Geometry",
                    topics: [
                        "Extracting geometric elements: edges, faces, points",
                        "Taking Measurements (distance, angles, volumes)",
                        "Getting Sharp Edges and Face Properties",
                        "Creating Geometrical Elements via automation"
                    ]
                },
                {
                    number: 5,
                    title: "Working with Products (Assemblies)",
                    topics: [
                        "Creating a new Product Document",
                        "Adding existing Parts to Products",
                        "Setting Product Properties",
                        "Extracting Product structure and BOM",
                        "Getting Part from Product",
                        "Calculating Product Distance, Clearance, etc."
                    ]
                },
                {
                    number: 6,
                    title: "Export & Reporting",
                    topics: [
                        "Exporting BOM to Excel",
                        "Generating PDFs from Drawings (with standards)",
                        "Data extraction from Parts, Drawings, and Products",
                        "Creating a Clearance Report using Python"
                    ]
                },
                {
                    number: 7,
                    title: "Python Language Essentials for CATIA",
                    topics: [
                        "Understanding Classes, Modules, Dictionaries",
                        "Working with Try-Except (Try-Catch) blocks",
                        "Reading and writing JSON files",
                        "File handling basics (read, write, append)",
                        "Debugging techniques in PyCharm"
                    ]
                },
                {
                    number: 8,
                    title: "UI Development for CATIA Tools",
                    topics: [
                        "Introduction to Tkinter for building CATIA automation tools",
                        "UI to:\nCreate a Line\nCreate a Disc Hub\nPerform DFM Analysis",
                        "Basic Input/Output forms and validation",
                        "Integrating UI with CATIA scripting backend"
                    ]
                },
                {
                    number: 9,
                    title: "Project Work",
                    topics: [
                        "Mini Project 1: Automate Part & Drawing Generation for Standard Components",
                        "Mini Project 2: Assembly BOM Extractor with Excel Export",
                        "Capstone Project: UI-based Tool for Product Analysis (DFM + Clearance + PDF Export)"
                    ]
                }
            ]
        }
    ],

    toolsAndResources: {
        title: "Tools & Resources",
        software: [
            "CATIA V5 RXX",
            "Python 3.9+",
            "PyCharm",
            "Excel"
        ],
        libraries: [
            "win32com.client",
            "tkinter",
            "json",
            "openpyxl"
        ],
        standards: [
            "Drafting standards (ISO/ANSI) for automated outputs"
        ]
    },

    videos: [
        {
            category: "Python for CATIA Automation & Customization",
            title: "CATIA Rename GeoSets Name Using Active Excel and Python Programming",
            videoUrl:
                "https://www.youtube.com/embed/puoMF5TClIc?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=1&forigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&vf=1"
        },
        {
            category: "CATIA Fillet Faces Customization & Automation using Python",
            title: "Highlight Fillet Faces in CATIA using Python Programming",
            videoUrl:
                "https://www.youtube.com/embed/2KnloceIYhA?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=3&forigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&vf=1"
        },
        {
            category: "CATIA Hole Feature Color Automation & Customization using Python",
            title: "CATIA Hole Feature Color Automation & Customization using Python",
            videoUrl:
                "https://www.youtube.com/embed/pkjPb48afJE?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=5&forigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&vf=1"
        },
        {
            category: "PartList Python CATIA Automation & Customization",
            title: "PartList Python CATIA Automation & Customization",
            videoUrl:
                "https://www.youtube.com/embed/FS7c1mONvJI?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=7&forigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&vf=1"
        },
        {
            category: "Wheel Hub Design Automation using Python and CATIA",
            title: "Wheel Hub Design Automation using Python and CATIA",
            videoUrl:
                "https://www.youtube.com/embed/95VlYO8LHJI?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=9&forigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&vf=1"
        },
        {
            category: "Corner Relief Python CATIA V5 Automation & Customization",
            title: "Corner Relief Python CATIA V5 Automation & Customization",
            videoUrl:
                "https://www.youtube.com/embed/BtvPts7wdBE?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=11&forigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&vf=1"
        },
        {
            category: "Complete Courses",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=13&forigin=https%3A%2F%2Ffeesworth.com%2Fpython-catia-automation-customization%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&vf=1"
        }
    ],

    faq: [
        {
            question: "What is CATIA customization using Python?",
            answer:
                "CATIA customization with Python involves writing scripts to automate repetitive tasks, enhance modeling workflows, and integrate CATIA with other systems. Python allows you to control CATIA features like part design, assemblies, and drafting more efficiently."
        },
        {
            question: "Why use Python for CATIA automation instead of CATScript or VBScript?",
            answer:
                "Python is modern, easy to learn, and far more powerful. It offers better readability, a large ecosystem of libraries, and is ideal for building scalable and maintainable automation tools. Unlike legacy macros, Python integrates well with databases, APIs, and data analysis tools."
        },
        {
            question: "What can be automated in CATIA using Python?",
            answer:
                "Almost everything—part modeling, feature creation, assembly automation, drawing generation, parameter updates, BOM extraction, data export/import, and design rule checks."
        },
        {
            question: "Do I need programming experience to get started?",
            answer:
                "Basic programming knowledge helps, but our solutions are designed to be clean, well-documented, and easy to extend. For internal teams, we can also provide onboarding support to maintain or expand the tools."
        },
        {
            question: "Is CATIA Python automation officially supported?",
            answer:
                "While CATIA does not offer native Python support like some other platforms, Python can interact with CATIA via COM (Component Object Model) and Windows automation APIs. This approach is widely used and effective for enterprise-level customization."
        },
        {
            question: "Can you integrate CATIA with Excel or databases using Python?",
            answer:
                "Absolutely. We frequently build Python-based tools that link CATIA with Excel, CSV files, SQL databases, ERP/PLM systems, and cloud APIs to streamline data flow and reporting."
        },
        {
            question: "What industries benefit the most from CATIA automation?",
            answer:
                "Industries with complex or repetitive CAD tasks—like aerospace, automotive, manufacturing, and tooling—benefit significantly. Automation improves speed, consistency, and reduces manual errors."
        },
        {
            question: "Can you help modernize our existing CATIA macros?",
            answer:
                "Yes. We can refactor legacy VBScript or CATScript macros into Python-based solutions that are faster, easier to maintain, and integrate with modern systems."
        }
    ]
};

export default catiaPythonCourse;